module.exports = __webpack_public_path__ + "img/guide-en-2.e0d532b4.png";